<div class="row g-2">
  <app-site-select
    bindValue="site_id"
    [class]="multiSelect && (sitesById == null || sitesById.size > 1) ? 'col-12 col-sm-6' : 'col'"
    [sites]="sites"
    [ngModel]="primarySiteId"
    [clearable]="false"
    [disabled]="disabled || (loadedSites?.length === 0)"
    [placeholder]="(loadedSites?.length === 0) ? ('No sites' | messageTranslate) : null"
    (ngModelChange)="updatePrimarySelectedSite($event)"
    (sitesLoaded)="updateSiteOptions($event)"
    (clientsLoaded)="updateClients($event)"
    (closeEvent)="onTouchedFn()"/>

  @if (multiSelect && (sitesById == null || sitesById.size > 1) && primarySiteId != null) {
    <div class="col-12 col-sm-6">
      @if (!secondaryControlEditMode) {
        <button
          class="btn btn-link fw-bold text-decoration-none"
          [disableTooltip]="secondarySiteIds?.length < 1"
          [ngbTooltip]="secondarySitesTooltipContent"
          [disabled]="disabled || loadedSites == null"
          (click)="updatedSecondarySiteListEditMode(true)">
          <div class="d-flex gap-2">
            <fa-icon [icon]="secondaryButtonIcon"/>
            <span>
              {{ secondarySiteIds?.length
                ? ((secondarySiteIds.length === 1 ? '+1 Site' : '+X Sites') | messageTranslate : {siteCount: secondarySiteIds.length})
                : (secondaryAddButtonText | messageTranslate)
              }}
            </span>
          </div>
        </button>
      } @else {
        <app-site-select
          #secondarySiteSelect
          bindValue="site_id"
          [sites]="loadedSites"
          [placeholder]="secondarySelectPlaceholder | messageTranslate"
          [ngModel]="secondarySiteIds"
          [multiSelect]="true"
          [maxSelectedLabels]="0"
          [maxSelectedItemName]="secondarySiteIds?.length > 1 ? sitesItemName : singleSiteItemName"
          [closeOnSelect]="false"
          [disabled]="disabled"
          [disabledSiteIds]="[primarySiteId]"
          [forceShowGroup]="true"
          (ngModelChange)="updateSecondarySelectedSites($event)"
          (closeEvent)="updatedSecondarySiteListEditMode(false); onTouchedFn();"/>
      }
    </div>
  }
</div>

<ng-template #secondarySitesTooltipContent>
  <ul class="text-start list-unstyled p-0">
    <!-- Using `$index` for identity tracking because site names can repeat -->
    @for (siteName of secondarySiteNames; track $index) {
      <li>
        &bull; {{siteName}}
      </li>
    }
  </ul>
</ng-template>
